/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_1_TitleInputs */

const en_landing_how_1_title = /** @type {(inputs: Landing_How_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the idea`)
};

const id_landing_how_1_title = /** @type {(inputs: Landing_How_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceritakan idenya`)
};

/**
* | output |
* | --- |
* | "Describe the idea" |
*
* @param {Landing_How_1_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const landing_how_1_title = /** @type {((inputs?: Landing_How_1_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_1_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_landing_how_1_title(inputs)
	return en_landing_how_1_title(inputs)
});